module.exports = __webpack_public_path__ + "static/media/2-en.7a0c34f3.svg";